import * as React from 'react';
import './SetScoreComponent.css';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import constants from '../../../../../constants/constants';
import { useState } from 'react';

function SetScoreComponent(props) {
    const [playerOneSetValue, setPlayerOneSetValue] = useState('');
    const [playerTwoSetValue, setPlayerTwoSetValue] = useState('');

    let key = props.keyNumber;
    const maxScore = props.maxScore ?? 7;
    const scoreOptions = Array.from({ length: maxScore + 1 }, (_, i) => i);

    const handleChange = (value) => {
        if (value.name === `player-one-set-${key}`) {
            setPlayerOneSetValue(value.value);
        } else if (value.name === `player-two-set-${key}`) {
            setPlayerTwoSetValue(value.value);
        }
        props.handleChange(value);
    };
    return (
        <div key={key} className={`set-score-container row ${props.hasError ? 'set-score-error' : ''}`}>
            <div className='col-4'>
                <span className='span-set-score-number'>
                    {constants.ADD_GAME.SET} {key}
                </span>
            </div>
            <div className='col-4'>
                <Select
                    value={playerOneSetValue}
                    size='small'
                    name={`player-one-set-${key}`}
                    onChange={(value) => handleChange(value.target)}
                    displayEmpty
                >
                    {scoreOptions.map((score) => (
                        <MenuItem key={score} value={`${score}`}>
                            {score}
                        </MenuItem>
                    ))}
                </Select>
            </div>
            <div className='col-4'>
                <Select
                    value={playerTwoSetValue}
                    size='small'
                    name={`player-two-set-${key}`}
                    onChange={(value) => handleChange(value.target)}
                    displayEmpty
                >
                    {scoreOptions.map((score) => (
                        <MenuItem key={score} value={`${score}`}>
                            {score}
                        </MenuItem>
                    ))}
                </Select>
            </div>
        </div>
    );
}

export default SetScoreComponent;
